<template>
     <div class="box_gallerry" >
        <div class="box_gallerry_content">
            <div
                ref="firstGallery"
                class="woocommerce-product-gallery customise woocommerce-product-gallery--first splide"
                :data-total_image="totalImage"
                style="opacity: 1"
            >
                <div
                class="product-imgs woocommerce-product-gallery__wrapper splide__track"
                >
                <div
                    id="gallery2"
                    ref="galleryImage"
                    class="product-image-wrapper gallery splide__list"
                    :class="galleryClass"
                    :style="{ maxHeight: maxHeight + 'px' }"
                    v-if="!isVideoActive"
                >
                    <template v-for="(item, index) in data" :key="index">
                    <div
                        v-if="item.type === 'image' "
                        class="woocommerce-product-gallery__image splide__slide"
                        :class="[
                        'splide__slide gallery-item',
                        { 'first-slide': index === 0 },
                        getSlideWidth(index)
                        ]"
                    >
                        <div v-if="index === 0 && thumb && thumb !== '' && isMobile == false " class="box-video" @click="showPopupVideo" >
                        <svg width="44" height="28" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.9592 5.65714C27.7699 5.74104 27.6844 5.96255 27.7683 6.1519L29.1354 9.23761C29.2193 9.42696 29.4408 9.51246 29.6301 9.42856C29.8195 9.34467 29.905 9.12316 29.8211 8.9338L28.6059 6.19095L31.3487 4.97573C31.5381 4.89183 31.6236 4.67032 31.5397 4.48097C31.4558 4.29161 31.2343 4.20612 31.0449 4.29002L27.9592 5.65714ZM5.15473 6.7132C5.34339 6.62774 5.42705 6.40553 5.34159 6.21688C5.25613 6.02823 5.03392 5.94457 4.84527 6.03003L5.15473 6.7132ZM32.625 10.603C32.625 11.3498 32.248 12.0993 31.485 12.8205C30.7213 13.5424 29.5961 14.2098 28.1745 14.7782C25.3334 15.9141 21.3828 16.625 17 16.625V17.375C21.4538 17.375 25.5031 16.6539 28.4529 15.4746C29.9268 14.8853 31.1447 14.1742 32.0002 13.3655C32.8566 12.556 33.375 11.6226 33.375 10.603H32.625ZM17 16.625C12.6172 16.625 8.66658 15.9141 5.82551 14.7782C4.40393 14.2098 3.27868 13.5424 2.51496 12.8205C1.75203 12.0993 1.375 11.3498 1.375 10.603H0.625C0.625 11.6226 1.1434 12.556 1.99976 13.3655C2.85533 14.1742 4.07322 14.8853 5.54708 15.4746C8.49686 16.6539 12.5462 17.375 17 17.375V16.625ZM27.9761 6.34985C29.4571 6.92145 30.6328 7.59915 31.4317 8.33571C32.2303 9.07188 32.625 9.83898 32.625 10.603H33.375C33.375 9.55962 32.8324 8.60692 31.9401 7.78428C31.0482 6.96203 29.7794 6.2419 28.2461 5.65015L27.9761 6.34985ZM1.375 10.603C1.375 9.91657 1.69294 9.22915 2.33635 8.56214C2.98148 7.89335 3.93633 7.26512 5.15473 6.7132L4.84527 6.03003C3.57421 6.6058 2.52907 7.28207 1.79656 8.04144C1.06234 8.80259 0.625 9.667 0.625 10.603H1.375Z" fill="black"/>
                            <path d="M9.91 2.3C10.3433 2.3 10.7133 2.38 11.02 2.54C11.3333 2.69333 11.57 2.9 11.73 3.16C11.89 3.42 11.97 3.70667 11.97 4.02C11.97 4.32667 11.9133 4.60333 11.8 4.85C11.6867 5.09667 11.5333 5.29333 11.34 5.44C11.1533 5.58 10.95 5.65 10.73 5.65V5.67C11.15 5.67 11.4867 5.82333 11.74 6.13C11.9933 6.43 12.12 6.79667 12.12 7.23C12.12 7.58333 12.0233 7.90333 11.83 8.19C11.6433 8.47667 11.3733 8.7 11.02 8.86C10.6667 9.02 10.26 9.1 9.8 9.1C8.7 9.1 7.94 8.57333 7.52 7.52L8.26 7.13C8.39333 7.53667 8.57667 7.84333 8.81 8.05C9.05 8.25 9.4 8.35 9.86 8.35C10.3067 8.35 10.6567 8.24 10.91 8.02C11.1633 7.79333 11.29 7.50333 11.29 7.15C11.29 6.74333 11.1667 6.46 10.92 6.3C10.68 6.13333 10.2967 6.05 9.77 6.05H9.51V5.3H9.77C10.6833 5.3 11.14 4.92667 11.14 4.18C11.14 3.80667 11.0333 3.52667 10.82 3.34C10.6133 3.14667 10.3133 3.05 9.92 3.05C9.53333 3.05 9.22333 3.14 8.99 3.32C8.76333 3.49333 8.60667 3.74 8.52 4.06L7.77 3.71C7.93 3.27667 8.2 2.93333 8.58 2.68C8.96667 2.42667 9.41 2.3 9.91 2.3ZM16.1201 2.3C16.6467 2.3 17.0767 2.41 17.4101 2.63C17.7434 2.85 18.0134 3.20333 18.2201 3.69L17.4801 4.04C17.2667 3.38 16.7967 3.05 16.0701 3.05C15.7234 3.05 15.4134 3.17333 15.1401 3.42C14.8734 3.66667 14.6634 4.00333 14.5101 4.43C14.3634 4.85667 14.2901 5.33 14.2901 5.85V6.03H14.3301C14.4301 5.63667 14.6567 5.33667 15.0101 5.13C15.3634 4.92333 15.7401 4.82 16.1401 4.82C16.8134 4.82 17.3501 5.01333 17.7501 5.4C18.1567 5.78667 18.3601 6.30667 18.3601 6.96C18.3601 7.61333 18.1534 8.13333 17.7401 8.52C17.3334 8.90667 16.7834 9.1 16.0901 9.1C15.5501 9.1 15.0867 8.95667 14.7001 8.67C14.3201 8.37667 14.0301 7.97667 13.8301 7.47C13.6367 6.95667 13.5401 6.36667 13.5401 5.7C13.5401 4.98 13.6501 4.36667 13.8701 3.86C14.0967 3.34667 14.4034 2.96 14.7901 2.7C15.1834 2.43333 15.6267 2.3 16.1201 2.3ZM16.0801 5.59C15.6534 5.59 15.3067 5.71667 15.0401 5.97C14.7734 6.22333 14.6401 6.55 14.6401 6.95C14.6401 7.36333 14.7701 7.69667 15.0301 7.95C15.2967 8.20333 15.6467 8.33 16.0801 8.33C16.5334 8.33 16.8867 8.21 17.1401 7.97C17.3934 7.72333 17.5201 7.38333 17.5201 6.95C17.5201 6.53 17.3934 6.2 17.1401 5.96C16.8867 5.71333 16.5334 5.59 16.0801 5.59ZM22.1217 9.1C21.3217 9.1 20.7117 8.81 20.2917 8.23C19.8717 7.65 19.6617 6.80667 19.6617 5.7C19.6617 4.59333 19.8717 3.75 20.2917 3.17C20.7117 2.59 21.3217 2.3 22.1217 2.3C22.9217 2.3 23.5317 2.59 23.9517 3.17C24.3717 3.75 24.5817 4.59333 24.5817 5.7C24.5817 6.80667 24.3717 7.65 23.9517 8.23C23.5317 8.81 22.9217 9.1 22.1217 9.1ZM22.1217 8.38C22.6484 8.38 23.0517 8.15333 23.3317 7.7C23.6117 7.24 23.7517 6.57333 23.7517 5.7C23.7517 4.82667 23.6117 4.16333 23.3317 3.71C23.0517 3.25 22.6484 3.02 22.1217 3.02C21.5951 3.02 21.1917 3.25 20.9117 3.71C20.6317 4.16333 20.4917 4.82667 20.4917 5.7C20.4917 6.57333 20.6317 7.24 20.9117 7.7C21.1917 8.15333 21.5951 8.38 22.1217 8.38Z" fill="black"/>
                            <circle cx="27.5" cy="1.5" r="1.125" stroke="black" stroke-width="1"/>
                        </svg>
                        </div>
                        <a
                        :href="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`"
                        data-pswp-width="1000"
                        data-pswp-height="1000"
                        >
                        <template v-if="isZoomable[index]">
                            <VueInnerImageZoom
                            v-if="item.zoomsrc"
                            :src="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`"
                            :zoomScale="1"
                            :zoomType="'hover'"
                            :alt="item.alt || `${props.name || ''}${props.material ? ' in ' + props.material : ''} - SK Jewellery`"
                            />
                        </template>
                        <template v-else>
                            <img
                            :src="`${baseUrl}api/wp-content/uploads/${item.zoomsrc}`"
                            :alt="item.alt || `${props.name || ''}${props.material ? ' in ' + props.material : ''} - SK Jewellery`"
                            />
                        </template>
                        </a>
                    </div>
                    </template>
                </div>
                <div
                    v-if="props.isPre0rder"
                    class="pre-order-badge-wrapper"
                    data-tag="59"
                >
                    <div class="pre-order-badge">Preorder</div>
                </div>
                <div v-if="isVideoActive && isMobile" class="video-container">
                    <video
                        poster=""
                        playsinline
                        width="100%"
                        height="100%"
                        class="video-gallery-mobile"
                        loop
                        autoplay
                        :src="thumb"
                    >
                    <source :src="thumb" type="video/mp4" />
                    </video>
                    </div>
                </div>
                <div v-if="thumb && thumb !== '' && isMobile " class="box-video-mobile"  :class="{ 'active': isVideoActive }"  @click="toggleVideo" >
                        <svg v-if="!isVideoActive"  width="44" height="28" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.9592 5.65714C27.7699 5.74104 27.6844 5.96255 27.7683 6.1519L29.1354 9.23761C29.2193 9.42696 29.4408 9.51246 29.6301 9.42856C29.8195 9.34467 29.905 9.12316 29.8211 8.9338L28.6059 6.19095L31.3487 4.97573C31.5381 4.89183 31.6236 4.67032 31.5397 4.48097C31.4558 4.29161 31.2343 4.20612 31.0449 4.29002L27.9592 5.65714ZM5.15473 6.7132C5.34339 6.62774 5.42705 6.40553 5.34159 6.21688C5.25613 6.02823 5.03392 5.94457 4.84527 6.03003L5.15473 6.7132ZM32.625 10.603C32.625 11.3498 32.248 12.0993 31.485 12.8205C30.7213 13.5424 29.5961 14.2098 28.1745 14.7782C25.3334 15.9141 21.3828 16.625 17 16.625V17.375C21.4538 17.375 25.5031 16.6539 28.4529 15.4746C29.9268 14.8853 31.1447 14.1742 32.0002 13.3655C32.8566 12.556 33.375 11.6226 33.375 10.603H32.625ZM17 16.625C12.6172 16.625 8.66658 15.9141 5.82551 14.7782C4.40393 14.2098 3.27868 13.5424 2.51496 12.8205C1.75203 12.0993 1.375 11.3498 1.375 10.603H0.625C0.625 11.6226 1.1434 12.556 1.99976 13.3655C2.85533 14.1742 4.07322 14.8853 5.54708 15.4746C8.49686 16.6539 12.5462 17.375 17 17.375V16.625ZM27.9761 6.34985C29.4571 6.92145 30.6328 7.59915 31.4317 8.33571C32.2303 9.07188 32.625 9.83898 32.625 10.603H33.375C33.375 9.55962 32.8324 8.60692 31.9401 7.78428C31.0482 6.96203 29.7794 6.2419 28.2461 5.65015L27.9761 6.34985ZM1.375 10.603C1.375 9.91657 1.69294 9.22915 2.33635 8.56214C2.98148 7.89335 3.93633 7.26512 5.15473 6.7132L4.84527 6.03003C3.57421 6.6058 2.52907 7.28207 1.79656 8.04144C1.06234 8.80259 0.625 9.667 0.625 10.603H1.375Z" fill="black"/>
                            <path d="M9.91 2.3C10.3433 2.3 10.7133 2.38 11.02 2.54C11.3333 2.69333 11.57 2.9 11.73 3.16C11.89 3.42 11.97 3.70667 11.97 4.02C11.97 4.32667 11.9133 4.60333 11.8 4.85C11.6867 5.09667 11.5333 5.29333 11.34 5.44C11.1533 5.58 10.95 5.65 10.73 5.65V5.67C11.15 5.67 11.4867 5.82333 11.74 6.13C11.9933 6.43 12.12 6.79667 12.12 7.23C12.12 7.58333 12.0233 7.90333 11.83 8.19C11.6433 8.47667 11.3733 8.7 11.02 8.86C10.6667 9.02 10.26 9.1 9.8 9.1C8.7 9.1 7.94 8.57333 7.52 7.52L8.26 7.13C8.39333 7.53667 8.57667 7.84333 8.81 8.05C9.05 8.25 9.4 8.35 9.86 8.35C10.3067 8.35 10.6567 8.24 10.91 8.02C11.1633 7.79333 11.29 7.50333 11.29 7.15C11.29 6.74333 11.1667 6.46 10.92 6.3C10.68 6.13333 10.2967 6.05 9.77 6.05H9.51V5.3H9.77C10.6833 5.3 11.14 4.92667 11.14 4.18C11.14 3.80667 11.0333 3.52667 10.82 3.34C10.6133 3.14667 10.3133 3.05 9.92 3.05C9.53333 3.05 9.22333 3.14 8.99 3.32C8.76333 3.49333 8.60667 3.74 8.52 4.06L7.77 3.71C7.93 3.27667 8.2 2.93333 8.58 2.68C8.96667 2.42667 9.41 2.3 9.91 2.3ZM16.1201 2.3C16.6467 2.3 17.0767 2.41 17.4101 2.63C17.7434 2.85 18.0134 3.20333 18.2201 3.69L17.4801 4.04C17.2667 3.38 16.7967 3.05 16.0701 3.05C15.7234 3.05 15.4134 3.17333 15.1401 3.42C14.8734 3.66667 14.6634 4.00333 14.5101 4.43C14.3634 4.85667 14.2901 5.33 14.2901 5.85V6.03H14.3301C14.4301 5.63667 14.6567 5.33667 15.0101 5.13C15.3634 4.92333 15.7401 4.82 16.1401 4.82C16.8134 4.82 17.3501 5.01333 17.7501 5.4C18.1567 5.78667 18.3601 6.30667 18.3601 6.96C18.3601 7.61333 18.1534 8.13333 17.7401 8.52C17.3334 8.90667 16.7834 9.1 16.0901 9.1C15.5501 9.1 15.0867 8.95667 14.7001 8.67C14.3201 8.37667 14.0301 7.97667 13.8301 7.47C13.6367 6.95667 13.5401 6.36667 13.5401 5.7C13.5401 4.98 13.6501 4.36667 13.8701 3.86C14.0967 3.34667 14.4034 2.96 14.7901 2.7C15.1834 2.43333 15.6267 2.3 16.1201 2.3ZM16.0801 5.59C15.6534 5.59 15.3067 5.71667 15.0401 5.97C14.7734 6.22333 14.6401 6.55 14.6401 6.95C14.6401 7.36333 14.7701 7.69667 15.0301 7.95C15.2967 8.20333 15.6467 8.33 16.0801 8.33C16.5334 8.33 16.8867 8.21 17.1401 7.97C17.3934 7.72333 17.5201 7.38333 17.5201 6.95C17.5201 6.53 17.3934 6.2 17.1401 5.96C16.8867 5.71333 16.5334 5.59 16.0801 5.59ZM22.1217 9.1C21.3217 9.1 20.7117 8.81 20.2917 8.23C19.8717 7.65 19.6617 6.80667 19.6617 5.7C19.6617 4.59333 19.8717 3.75 20.2917 3.17C20.7117 2.59 21.3217 2.3 22.1217 2.3C22.9217 2.3 23.5317 2.59 23.9517 3.17C24.3717 3.75 24.5817 4.59333 24.5817 5.7C24.5817 6.80667 24.3717 7.65 23.9517 8.23C23.5317 8.81 22.9217 9.1 22.1217 9.1ZM22.1217 8.38C22.6484 8.38 23.0517 8.15333 23.3317 7.7C23.6117 7.24 23.7517 6.57333 23.7517 5.7C23.7517 4.82667 23.6117 4.16333 23.3317 3.71C23.0517 3.25 22.6484 3.02 22.1217 3.02C21.5951 3.02 21.1917 3.25 20.9117 3.71C20.6317 4.16333 20.4917 4.82667 20.4917 5.7C20.4917 6.57333 20.6317 7.24 20.9117 7.7C21.1917 8.15333 21.5951 8.38 22.1217 8.38Z" fill="black"/>
                            <circle cx="27.5" cy="1.5" r="1.125" stroke="black" stroke-width="2"/>
                        </svg>
                        <svg v-else class="close" width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z" fill="#000000b3"/>
                        </svg>
                    </div>
            </div>
           
        </div>
    </div>

  <div
    v-if="isPopupGalleryVisible"
    class="popup-overlay-video-gallery"
    @click="closePopupVideo"
  >
    <div class="popup-content-gallery">
      <video controls autoplay :src="popupVideoUrl" class="popup-video-gallery">
        <source :src="popupVideoUrl" type="video/mp4" />
      </video>
    </div>
    <button class="close-btn" @click="closePopupVideo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="button-svg"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"
        />
      </svg>
    </button>
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/components/product/_gallery.scss";
</style>

<script setup lang="ts">
import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
  computed,
} from "vue";
import Splide from "@splidejs/splide";
import { useVueInnerImageZoom } from "~/composables/useVueInnerImageZoom";
import { usePhotoSwipe } from "~/composables/usePhotoSwipe";

const VueInnerImageZoom = useVueInnerImageZoom();
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const { init } = usePhotoSwipe("#gallery2");
const firstSliderInstance = ref(null);
const isShowGallerySecond = ref(false);

const props = defineProps<{
  data: any[];
  variation: any[];
  galleryItems: any[];
  productGallery: any[];
  isPre0rder: boolean;
  thumb: string;
  maxHeight: number;
  material?: any;
  name?: string;
}>();

//console.log('--- prorp data: ',props)

const data = computed(() => props.data);
const thumb = computed(() => props.thumb);
const totalImage = ref(data.value.length);
const maxHeight = computed(() => props.maxHeight);
const secondGalleryHeight = ref(0);
const showGallerySecound = ref(true);
const isExpanded = ref(true);
const galleryImage = ref<HTMLElement | null>(null);
const firstGallery = ref<HTMLElement | null>(null);
const secondGallery = ref<HTMLElement | null>(null);
const isMobile = ref(false);
const isZoomable = ref<boolean[]>(new Array(data.value.length).fill(false));
const isVideoActive = ref(false);


const popupVideoUrl = ref('');
const showPopupVideo = () => {
    popupVideoUrl.value = props.thumb;
    isPopupGalleryVisible.value = true;
};

const closePopupVideo = () => {
    isPopupGalleryVisible.value = false;
    popupVideoUrl.value = '';
};
const dataVariation = ref(props.variation);

watch(() => props.data, async () => {
   if (window.innerWidth < 768) {
       dataVariation.value  = props.galleryItems ;
      await nextTick();
      initMobileGalleries();
   }
});

const toggleVideo = () => {
  isVideoActive.value = !isVideoActive.value;
  initMobileGalleries();
};


const getSlideWidth = (index:number) => {
    const totalSlides = props.data.length;
    if (index === 0) return 'w-full';
    if (totalSlides % 2 === 0) {
        if (index === totalSlides - 1) return 'w-full';
        return 'w-50';
    }
    return 'w-50';
};


const checkImageZoomable = async (index: number): Promise<void> => {

  try {
    const isZoomableForImage = await isImageZoomable(index);
    isZoomable.value[index] = isZoomableForImage;

  } catch {
    isZoomable.value[index] = false;
  }

};

const isImageZoomable = (index: number): Promise<boolean> => {
  return new Promise((resolve) => {
    const item = data.value[index];
    const containerWidth = galleryImage.value?.offsetWidth;

    if (!containerWidth) {
      resolve(false);
      return;
    }

    const img = new Image();
    img.src = `${baseUrl}api/wp-content/uploads/${item.zoomsrc}`;

    img.onload = () => {
      resolve(img.width >= containerWidth);
    };

    img.onerror = () => {
      resolve(false);
    };
  });
};

// const expanCloseSecondGallery = () => {
//   isExpanded.value = !isExpanded.value;
//   const arrow = document.querySelector(
//     ".second-gallery-expan-close svg",
//   ) as SVGElement;
//   if (arrow) {
//     arrow.style.transition = "transform 0.3s ease-in-out";
//     arrow.style.transform = isExpanded.value
//       ? "rotate(0deg)"
//       : "rotate(180deg)";
//   }
// };

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

// const isThumbImage = computed(() => {
//   return !thumb.value.endsWith(".mp4");
// });

// const thumbPosition = computed(() => {
//   if (totalImage.value === 0) return 0;
//   if (totalImage.value === 1) return 1;
//   return 2;
// });

const galleryClass = computed((): string => {
  if (totalImage.value <= 3) {
    return "product-image-one-col";
  }

  return totalImage.value % 2 === 0
    ? "product-image-even-col"
    : "product-image-odd-col";
});

// const showHideSecondGallery = () => {
//   showGallerySecound.value = !showGallerySecound.value;
  
//   const wrapper = document.querySelector(
//     ".woocommerce-product-gallery__wrapper",
//   );
//   if (wrapper) {
//     wrapper.style.transition = "max-height 0.3s ease-in-out";
//     wrapper.style.maxHeight = isExpanded.value
//       ? wrapper.scrollHeight + "px"
//       : "200px";
//   }
// };

function debounce(fn: Function, delay: number) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

const initMobileGalleries = async () => {
  if (window.innerWidth < 768) {

    if (firstSliderInstance.value) {
      firstSliderInstance.value.destroy();
    }

    await nextTick();

    firstSliderInstance.value = new Splide(
      ".woocommerce-product-gallery--first",
      {
        perMove: 1,
        pagination: {
          el: ".splide__pagination",
          type: "bullets",
          clickable: true,
        },
        perPage: 1,
        arrows: false,
        loop: true,
        drag: true,
        type: "loop",
        speed: 800,
        gap: "0",
      },
    );

    firstSliderInstance.value.mount();
  }
};



const handleResize = () => {
  checkMobile();

  if (window.innerWidth >= 768) {
    if (firstSliderInstance.value) {
      firstSliderInstance.value.destroy();
      firstSliderInstance.value = null;
    }

  } else {
    initMobileGalleries();
  }
};

const isPopupGalleryVisible = ref(false);



onMounted(() => {


  checkMobile();

  data.value.forEach((_, index) => {
    checkImageZoomable(index);
  });
  if (thumb.value) {
    totalImage.value = Number(totalImage.value) + 1;
  }
  init();
  initMobileGalleries();

  if (window.innerWidth < 768) {
    if (secondGallery.value) {
      secondGalleryHeight.value = secondGallery.value.offsetHeight;
    }

    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach((entry) => {
    //       if (secondGallery.value) {
    //         if (!entry.isIntersecting) {
             
    //           secondGallery.value.style.display = "block";
    //           if (secondGalleryHeight.value === 0) {
    //             secondGalleryHeight.value = secondGallery.value.offsetHeight;
    //             document.body.style.paddingTop = `${secondGalleryHeight.value}px`;
    //           }
    //           secondGallery.value.classList.add('gallery_second_show');
    //         } else {
    //         secondGallery.value.classList.remove('gallery_second_show');
    //           secondGallery.value.style.display = "none";
    //           document.body.style.paddingTop = "0px";
    //         }
    //       }
    //     });
    //   },
    //   { threshold: 0 },
    // );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (secondGallery.value) {
            if (!entry.isIntersecting) {
             
              secondGallery.value.style.display = "block";
              if (secondGalleryHeight.value === 0) {
                secondGalleryHeight.value = secondGallery.value.offsetHeight;
                document.body.style.paddingTop = `${secondGalleryHeight.value}px`;
              }
              isShowGallerySecond.value = true;
            } else {
           isShowGallerySecond.value = false;
              secondGallery.value.style.display = "none";
              document.body.style.paddingTop = "0px";
            }
          }
        });
      },
      { threshold: 0 },
    );

    if (firstGallery.value) {
      observer.observe(firstGallery.value);
    }

  }

  window.addEventListener("resize", debounce(handleResize, 250));
});

onUnmounted(() => {
  if (firstSliderInstance.value) {
    firstSliderInstance.value.destroy();
  }

  window.removeEventListener("resize", handleResize);
  document.body.style.paddingTop = "0px";
});
</script>